<template>
  <div>
    <confirm-box :dialog="dialog" @confirmed="deletePatient" @cancel="cancel" />
    <v-data-table
      :headers="tbHeaders"
      :items="familyMembers"
      :items-per-page="itemsPerPage"
      @page-count="pageCount = $event"
      :page.sync="page"
      item-key="id"
      hide-default-footer
      hide-default-header
    >
      <template v-slot:header="{ props: { headers } }">
        <thead class="header">
          <tr>
            <th v-for="header in headers" :key="header.text" class="header--text">
              <span v-if="header.value">{{ header.text }}</span>
            </th>
            
          </tr>
        </thead>
      </template>

      <template v-slot:item="{ index, item }">
        <tr>
          <td>{{ index + 1 }}</td>
          <td>{{ item.name }}</td>
          <td>{{ item.age }}</td>
          <td>{{ item.sex==1?"Male":"Female" }}</td>
          <td>{{ item.confirm==0 && item.relationship==1?"Family Member":item.relationship==3?"Close Contact":"Presumptive" }}</td>
          <td>
            <v-btn
              @click="openConfrimBox(item)"
              icon
              color="red lighten-1"
              class="white--text"
              depressed
            >
              <v-icon> mdi-delete-outline </v-icon>
            </v-btn>
            <v-btn
              @click="goUpdateForm(item)"
              icon
              color="orange darken-1"
              class="white--text"
              depressed
            >
              <v-icon> mdi-pencil-outline </v-icon>
            </v-btn>
            <v-btn
              @click="goCiList(item)"
              icon
              color="green"
              class="white--text"
              depressed
            >
              <v-icon> mdi mdi-view-list </v-icon>
            </v-btn>
          </td>
        </tr>
      </template>
    </v-data-table>
    <div class="text-center py-3">
      <v-pagination color="purple accent-4" v-model="page" :length="pageCount"></v-pagination>
    </div>
  </div>
</template>

<script>
import ConfirmBox from "@/components/notification/ConfirmBox";

import { mapState } from "vuex";
export default {
  components: {
    ConfirmBox
  },
  data: () => ({
    item: {},
    dialog: false,
    pageCount: 0,
    page: 1,
    itemsPerPage: 10,
    tbHeaders: [
      { text: "No", value: "no" },
      { text: "Name", value: "name" },
      { text: "Age", value: "age" },
      { text: "Sex", value: "sex" },
      { text: "Status", value: "status" },
      { text: "Actions", value: "" }
    ]
  }),
  computed: {
    ...mapState("FamilyMember", ["familyMembers"])
  },
  methods: {
    openConfrimBox(item) {
      this.item = item;
      this.dialog = !this.dialog;
    },
    deletePatient() {
      let data = {
        id: this.item.id
      };
      this.$store
        .dispatch("FamilyMember/deleteFamilyMember", data)
        .then(() => (this.dialog = !this.dialog));
    },
    cancel() {
      this.dialog = !this.dialog;
    },
    goUpdateForm(item) {
      this.$router.push({
        name: "patient-family-edit",
        params: {
          id: item.id
        }
      });
    },
    goCiList(item){
      this.$router.push({
        name: "patient-ci-list",
        params: {
          id: item.id,
          name:item.name
        }
      });
    }
  }
};
</script>

<style>
</style>